import SERVICE_URL from "../config/API_DATA";
import HttpPost from "../http/httppost.js";
import Logger from "./logger.js";
import { FILE_NAME, LOG_TYPE } from "../config/API_DATA";

export default class UpdatePricing {
    static buildRequest(
        pUpdatePricingReq
    ) {
        let returnValue = null;
        try {
            let body = {
                pricingid: pUpdatePricingReq.pricingId,
                airlineCode: pUpdatePricingReq.airLine,
                tier: pUpdatePricingReq.tierId,
                sector_type: pUpdatePricingReq.sector,
                travel_period_from: pUpdatePricingReq.travelFromDate,
                travel_period_to: pUpdatePricingReq.travelToDate,

                display_text: pUpdatePricingReq.name,
                b2bPricingCellss: pUpdatePricingReq.b2bPricingCellss
            };

            returnValue = body;
        } catch (err) {
            let body = Logger.buildRequest(
                FILE_NAME.API_UPDATE_PRICING,
                "error in building body for Update Pricing  api",
                err.toString(),
                "buildRequest",
                LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
        }
        return returnValue;
    }

    static async getResponse(pReqOptions) {
        let returnValue = null;
        try {
            returnValue = await HttpPost.makeHttpPostRequest(
                SERVICE_URL.UPDATE_PRICING,
                pReqOptions
            );
        } catch (err) {
            let body = Logger.buildRequest(
                FILE_NAME.API_UPDATE_PRICING,
                "error in getting Response from  Update Pricing api ",
                err.toString(),
                "getResponse",
                LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
        }
        return returnValue;
    }
}